'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dSelected$002dSite from "./presto.types$-Selected-Site.js";
var $p;
/** @constructor */
function $c_Lpresto_types$SelectedSite$() {
}
export { $c_Lpresto_types$SelectedSite$ as $c_Lpresto_types$SelectedSite$ };
$p = $c_Lpresto_types$SelectedSite$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$SelectedSite$;
/** @constructor */
function $h_Lpresto_types$SelectedSite$() {
}
export { $h_Lpresto_types$SelectedSite$ as $h_Lpresto_types$SelectedSite$ };
$h_Lpresto_types$SelectedSite$.prototype = $p;
$p.l = (function() {
  return "SelectedSite";
});
$p.adJ = (function(x$0) {
  return new $j_presto$002etypes$0024$002dSelected$002dSite.$c_Lpresto_types$SelectedSite(x$0.j(0), (!(!x$0.j(1))));
});
var $d_Lpresto_types$SelectedSite$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$SelectedSite$, "presto.types$SelectedSite$", ({
  a1G: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$SelectedSite$ as $d_Lpresto_types$SelectedSite$ };
var $n_Lpresto_types$SelectedSite$;
function $m_Lpresto_types$SelectedSite$() {
  if ((!$n_Lpresto_types$SelectedSite$)) {
    $n_Lpresto_types$SelectedSite$ = new $c_Lpresto_types$SelectedSite$();
  }
  return $n_Lpresto_types$SelectedSite$;
}
export { $m_Lpresto_types$SelectedSite$ as $m_Lpresto_types$SelectedSite$ };
//# sourceMappingURL=presto.types$-Selected-Site$.js.map
